export const productdetailtabs = () => {};

/**
 * items type 을 가진 design_collection_content_item 을 추출
 * type 이 items 인 것들은 연관 상품 목록인 design_collection_content_item 임
 * @param design_collection
 * @returns {[undefined,*[]]|[undefined,null]}
 */
export const extractRelationDesignCollectionContent = (design_collection) => {
  if (!design_collection || Object.keys(design_collection).length === 0 || !design_collection._)
    return [design_collection, null];
  const { design_collection_contents } = design_collection?._;
  if (!design_collection_contents) return [design_collection, null];

  const stIdx = design_collection_contents.findLastIndex((item) =>
    ['items', 'items_5', 'items_6'].includes(item.type),
  );
  if (stIdx === -1 || stIdx - 1 < 0) return [design_collection, null];
  if (!['h1', 'p1'].includes(design_collection_contents[stIdx - 1].type)) return [design_collection, null];

  const extractedItems = [design_collection_contents[stIdx - 1], design_collection_contents[stIdx]];
  const copiedDesignCollection = {
    ...design_collection,
    _: {
      ...design_collection._,
      design_collection_contents: design_collection_contents.filter(
        (_, index) => index !== stIdx - 1 && index !== stIdx,
      ),
    },
  };
  return [copiedDesignCollection, extractedItems];
};

export const extractFirstPatternWithFullImg = (design_collection) => {
  if (!design_collection || Object.keys(design_collection).length === 0 || !design_collection._)
    return [null, design_collection];
  const { design_collection_contents } = design_collection._;
  if (!design_collection_contents) return [null, design_collection];

  // h1 -> p1 -> (full_img | banner) 패턴 추출
  const isValidPattern = (startIdx) =>
    design_collection_contents[startIdx]?.type === 'h1' &&
    design_collection_contents[startIdx + 1]?.type === 'p1' &&
    ['full_img', 'banner'].includes(design_collection_contents[startIdx + 2]?.type);

  const startIdx = design_collection_contents.findIndex((_, idx) => isValidPattern(idx));
  if (startIdx !== 0) return [null, design_collection];

  // 동일한 target_type (full_img | banner) 연속 추출
  let endIdx = startIdx + 2;
  const targetType = design_collection_contents[endIdx].type;
  while (design_collection_contents[endIdx + 1]?.type === targetType) {
    endIdx++;
  }

  const extractedItems = design_collection_contents.slice(startIdx, endIdx + 1);
  const copiedDesignCollection = {
    ...design_collection,
    _: {
      ...design_collection._,
      design_collection_contents: design_collection_contents.filter(
        (_, index) => index < startIdx || index > endIdx,
      ),
    },
  };
  return [extractedItems, copiedDesignCollection];
};
